import { render, staticRenderFns } from "./SubmitBulkQueriesModal.vue?vue&type=template&id=6fdd1a7c&"
import script from "./SubmitBulkQueriesModal.vue?vue&type=script&lang=js&"
export * from "./SubmitBulkQueriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports